import { ContextualAttachment } from '@/features/ai-agents/shared/models';

export interface EditorConfigItem {
  code: string;
  name: string;
  description: string;
}

export interface EditorConfig {
  name?: string;
  cleanup?: EditorConfigItem;
  states?: Record<string, EditorConfigItem>;
  actions?: Record<string, EditorConfigItem>;
  sections?: Record<string, string>;
}

const EDITOR_CONFIG_REGEX = /```vsly\/json\/editor\n([\s\S]*?)\n```/;

export function sanitizeKeyName(key: string): string {
  return key.replace(/[^a-zA-Z0-9_$]/g, `_`);
}

export function extractEditorConfig(content: string): EditorConfig | null {
  if (!content) return null;
  const match = content.match(EDITOR_CONFIG_REGEX);
  if (match && match[1]) {
    try {
      return JSON.parse(match[1]) as EditorConfig;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Failed to parse editor config JSON`, e);
    }
  }
  return null;
}

export function applySectionCaptions(
  attachments: ContextualAttachment[],
  editorConfig: EditorConfig | null,
): ContextualAttachment[] {
  if (
    !editorConfig?.sections ||
    Object.keys(editorConfig.sections).length === 0
  ) {
    return attachments;
  }

  return attachments.map((attachment) => {
    const matchedSection = Object.entries(editorConfig.sections).find(
      ([key]) => {
        // Remove -css suffix if present for matching
        const attachmentId = attachment.id.endsWith(`-css`)
          ? attachment.id.slice(0, -4)
          : attachment.id;
        return key === attachmentId;
      },
    );

    if (matchedSection) {
      const [, newCaption] = matchedSection;
      return {
        ...attachment,
        caption: newCaption,
      };
    }

    return attachment;
  });
}
